module.exports = "<modal full-screen class=modal--zoom> <modal-header> <modal-close ng-click=$ctrl.onClose()></modal-close> </modal-header> <modal-content> <product-images class=product-images--column-view images=$ctrl.images on-click-image=$ctrl.onClickProductImage active-image=$ctrl.activeImage> </product-images> <div class=modal-zoom__image> <img qw-zoom ng-src={{$ctrl.activeImage.url}}> </div> </modal-content> </modal> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal-zoom-image/modal-zoom-image.template.html
// module id = 563
// module chunks = 0